module.exports = __webpack_public_path__ + "img/infrastructure-15.812a98ac.png";